import React, { useEffect } from 'react'
import { makeStyles, createStyles, Chip, Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { productCardData } from '../utils/constant'
import { useImageTranslation } from 'src/hooks'
import { viewItemList, selectItem } from 'src/utils/trackingCode'
import { Helmet  } from 'react-helmet'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minWidth: 1350,
    },
    hoverPointer: {
      cursor: 'pointer',
    },
    swiperSlide: {
      borderRadius: theme.spacing(3),
      width: theme.spacing(33),
    },
    swiperSlideChipBox: {
      position: 'absolute',
      top: 118,
      textAlign: 'left',
      borderRadius: 100,
      paddingBottom: theme.spacing(2),
      width: 'auto',
    },
    swiperSlideChip: {
      borderRadius: theme.spacing(12.5),
      backgroundColor: '#F3F4F6',
      marginTop: theme.spacing(1.5),
      width: '100%',
      minHeight: 40,
      padding: 9.5,
      paddingLeft: 0,
      paddingRight: 0,
    },
    swiperSlideChiplable: {
      marginLeft: 5,
      marginRight: 0,
      display: 'block',
      whiteSpace: 'normal',
      overflow: 'visible',
      wordBreak: 'break-all',
    },
    productCard: {
      // flexShrink: 0,
      width: 406,
      height: 270,
      borderRadius: '24px 24px 0 0',
    },
    swiperSlideImgBox: {
      textAlign: 'left',
      maxWidth: '100%',
      fontWeight: 600,
      fontSize: 18,
      color: 'black',
      paddingRight: 12,
      lineHeight: '150%',
    },
    product: {
      cursor: 'pointer',
    },
  }),
)

const Promotion = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()
  const history = useHistory()
  const productCard = productCardData.map((item) => {
    return {
      ...item,
      img: tImage(item.img, 'webp'),
      name: t(item.name),
    }
  })
  useEffect(()=>{
    viewItemList('product_list', 'Product List', productCard)
  },[])
  
  return (
    <Box width="100%" margin="0 auto">
      <Helmet>
        <meta name="description" content={t('glossary.product.prodect_list')} />
        <title>{t('seoTitle.productList')}</title>
      </Helmet>
      <Box margin={3} mt={3} mb={5}>
        <Box fontSize={26} fontWeight={600}>
          {t('glossary.product_list')}
        </Box>
        <Box mt={2} color="#4B5563">
          {t('glossary.product.prodect_list')}
        </Box>
      </Box>
      <Box>
        <Box display="flex" flexWrap="wrap">
          {productCard.map((item, index) => (
            <Box
              key="index"
              onClick={() => {
                selectItem('product_list', 'Product List', item,index)
                history.push(`/${i18n.language}` + item.path)
              }}
            >
              <Box
                className={classes.hoverPointer}
                border="1px solid #D1D5DB"
                height={486}
                width={406}
                borderRadius={24}
                mr={2.5}
                ml={2.5}
                mb={5.25}
              >
                <img className={classes.productCard} src={item.img} alt="product info banner" />
                <Box ml={3} position="relative">
                  <Box className={classes.swiperSlideImgBox} mb={1} mt={2}>
                    {item.name}
                  </Box>
                  {item.nameInclude ? (
                    <Box textAlign="left" color="#4B5563" mb={1.3} fontSize={14}>
                      {t('glossary.included_Take2Prophecy')}
                    </Box>
                  ) : (
                    ''
                  )}
                  <Box fontSize={18} fontWeight={600} color="secondary.main" textAlign="left" mt={1}>
                    {item.price}
                  </Box>
                  <Box className={classes.swiperSlideChipBox}>
                    <Chip
                      classes={{ label: classes.swiperSlideChiplable, root: classes.swiperSlideChip }}
                      label={t('glossary.discount', { field: item.discountprice })}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <Box height={128} />
    </Box>
  )
}

export default Promotion
